import React from "react";
import { Icon } from "uxp/components";
import './Loading.scss';
export const LoadingOverlay = props => {
    return React.createElement("div", { className: "query-editor-loading-overlay-container-e8abb6ff" },
        React.createElement(Loading, Object.assign({}, props)));
};
export const Loading = props => {
    const { message } = props;
    return React.createElement("div", { className: "query-editor-loading-container-e8abb6ff" }, !!message ? React.createElement(React.Fragment, null,
        message,
        " ",
        typeof message == 'string' ? React.createElement(Icon, { icon: ['fas', 'spinner'], spin: true }) : null,
        " ") : React.createElement(React.Fragment, null,
        "Loading...",
        React.createElement(Icon, { icon: ['fas', 'spinner'], spin: true })));
};
